
import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import i18n from '@/lang';


@Component({
  name: 'Announcement',
  components: {},
})
export default class Announcement extends Vue {
  @PropSync('show', { type: Boolean, default: true }) syncedShow!: boolean;
  @Prop({ type: String, default: '' }) readonly panelData!: any;
  @Prop({ type: Function }) readonly editNotify!: any;

  private isEdit: boolean = false;
  private bulletinText: string = '';
  @Watch('syncedShow')
  isSyncedShow(n: any, o: any) {
    if (n) {
       this.isEdit = false
       this.bulletinText = JSON.parse(JSON.stringify(this.panelData));
    }
  }
  created() {}
  closeDialog() {
    this.syncedShow = false;
  }
  submitForm() {
    if(this.bulletinText == this.panelData){
        return this.isEdit = !this.isEdit;
    }
    if (this.bulletinText) {
      this.editNotify('save', this.bulletinText);
      this.isEdit = !this.isEdit;
    } else {
      this.$toast(i18n.t('Home.公告内容不允许为空'));
    }
  }
}
